import permissionsMixin from './permissionsMixin';
import { Permissions } from '../enums/permissionsEnum';

import { mapGetters } from 'vuex';
import { ClientContextGetters, ProjectContextGetters } from '../store/getters';
export default {
	mixins: [permissionsMixin],
	computed: {
		...mapGetters({
			hasClient: [ClientContextGetters.HAS_CLIENT],
			hasProject: [ProjectContextGetters.HAS_PROJECT],
		}),

		canViewReports() {
			if (!this.hasProject) return false;
			if (this.hasPermissions([Permissions.Reports.View])) {
				return true;
			}
			return false;
		},
		canViewGrids() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Grids.View]);
		},
		canViewInventory() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Inventory.View]);
		},
		canViewActivity() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Activity.View]);
		},
		canViewReportBuilder() {
			if (!this.hasProject) return false;
			if (
				this.hasPermissions([
					Permissions.Tools.ReportBuilder.Report.View,
				]) ||
				this.hasPermissions([
					Permissions.Tools.ReportBuilder.Workbook.View,
				])
			) {
				return true;
			}
			return false;
		},
		canViewFormBuilder() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Tools.FormBuilder.View]);
		},
		canViewProjectClone() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Tools.ProjectClone.View]);
		},
		canViewActivityBuilder() {
			if (!this.hasProject) return false;
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.View,
			]);
		},
		canViewDataImport() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Tools.DataImport.View]);
		},
		canViewExport() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Tools.DataExport.View]);
		},

		canViewClientUserManagement() {
			if (!this.hasClient) return false;
			return this.hasPermissions([Permissions.Tools.UserManagement.View]);
		},
		canViewDataFields() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Settings.DataFields.View]);
		},
		canViewGeneralSettings() {
			if (!this.hasProject) return false;
			return this.hasPermissions([
				Permissions.Settings.GeneralSettings.View,
			]);
		},
		canViewMergeConditions() {
			if (!this.hasProject) return false;
			return this.hasPermissions([
				Permissions.Settings.MergeConditions.View,
			]);
		},
		canViewReferenceLists() {
			if (!this.hasProject) return false;
			return this.hasPermissions([
				Permissions.Settings.ReferenceLists.View,
			]);
		},
		canViewGridFields() {
			if (!this.hasProject) return false;
			return this.hasPermissions([Permissions.Settings.GridFields.View]);
		},
		canAddProjects() {
			if (!this.hasClient) return false;
			return this.hasPermissions([Permissions.ProjectManagement.Add]);
		},
		canEditProjects() {
			if (!this.hasClient) return false;
			return this.hasPermissions([Permissions.ProjectManagement.Edit]);
		},
		canDeleteProjects() {
			if (!this.hasClient) return false;
			return this.hasPermissions([Permissions.ProjectManagement.Delete]);
		},
		canViewProjects() {
			if (!this.hasClient) return false;
			return this.hasPermissions([Permissions.ProjectManagement.View]);
		},
		canViewTools() {
			if (
				this.canViewFormBuilder ||
				this.canViewReportBuilder ||
				this.canViewDataImport ||
				this.canViewUserManagement ||
				this.canViewActivityBuilder ||
				this.canViewProjectClone
			) {
				return true;
			}
			return false;
		},
		canViewSettings() {
			if (!this.hasProject) return false;
			if (
				this.canViewReferenceLists ||
				this.canViewDataFields ||
				this.canViewDataFields ||
				this.canViewGridFields ||
				this.canViewGeneralSettings ||
				this.canViewMergeConditions
			) {
				return true;
			}
			return false;
		},
		canViewUserManagement() {
			if (this.isSuperAdmin) return true;
			if (this.canViewClientUserManagement) {
				return true;
			}
			return false;
		},
		isSuperAdmin() {
			return this.hasPermissions();
		},
		canViewClients() {
			return this.isSuperAdmin;
		},
		canViewProjectsMenu() {
			if (!this.hasClient) return false;
			if (this.isSuperAdmin) {
				return true;
			} else if (
				this.canAddProjects ||
				this.canDeleteProjects ||
				this.canEditProjects ||
				this.canViewProjects
			) {
				return true;
			}
			return false;
		},
	},
};
